/**
 * Card list context — lets CardDetail navigate to prev / next card based on
 * where the user came from (a set, a search, a ranking…).
 *
 * Stored in sessionStorage so it survives full-page reloads but vanishes when
 * the tab closes.
 *
 * Usage:
 *   // When the user clicks a card inside a list:
 *   setCardListContext(visibleCardIds, { url: "/sets/sv3pt5", label: "151" });
 *
 *   // Inside CardDetail.jsx:
 *   const ctx = getCardListContext();
 *   const idx = ctx?.ids.indexOf(currentCardId);
 *   // → use ctx.ids[idx-1] / ctx.ids[idx+1] for prev / next
 */
const KEY = "card-list-context";

export function setCardListContext(ids, origin) {
  if (!Array.isArray(ids) || ids.length === 0) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ids, origin: origin || null }));
  } catch {
    /* private browsing — ignore */
  }
}

export function getCardListContext() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCardListContext() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
